export const borrowerApplicationColumns = [
  { key: 'applicationNumber', title: 'Proposal ID', type: 'proposalId' },
  { key: 'createDatetime', title: 'Submission Date', type: 'date' },
  { key: 'endUseOfFund', title: 'Loan Type', type: 'text' },
  { key: 'fundRequirement', title: 'Loan Amount', type: 'currency' },
  { key: 'status', title: 'Status', type: 'status' }
];

export const consultantProposalColumns = [
  { key: 'proposalId', title: 'Proposal ID', type: 'proposalId' },
  { key: 'applicationId', title: 'Application ID', type: 'text' },
  { key: 'applicationNumber', title: 'Application No.', type: 'text' },
  { key: 'borrowerName', title: 'Borrower Name', type: 'text' },
  { key: 'mobileNumber', title: 'Mobile', type: 'text' },
  { key: 'amount', title: 'Amount', type: 'currency' },
  { key: 'submittedDate', title: 'Submitted', type: 'date' },
  { key: 'status', title: 'Status', type: 'status' }
];

export const lenderNewProposalColumns = [
  { key: 'id', title: 'Proposal ID', type: 'proposalId' },
  { key: 'borrowerName', title: 'Borrower Name', type: 'maskedBorrower' },
  { key: 'loanType', title: 'Loan Type', type: 'text' },
  { key: 'loanAmount', title: 'Loan Amount', type: 'currency' },
  { key: 'dateReceived', title: 'Date Received', type: 'date' },
  { key: 'status', title: 'Status', type: 'status' },
  { key: 'industry', title: 'Industry', type: 'text' },
  { key: 'city', title: 'City', type: 'text' }
];

export const lenderIndicativeProposalColumns = [
  { key: 'id', title: 'Offer ID', type: 'proposalId', maxWidth: 20 },
  { key: 'borrowerName', title: 'Borrower Name', type: 'maskedBorrower', maxWidth: 50 },
  { key: 'loanType', title: 'Loan Type', type: 'text', maxWidth: 50 },
  { key: 'fundRequirement', title: 'Fund Requirement', type: 'currency', maxWidth: 50 },
  { key: 'loanOffered', title: 'Loan Offered', type: 'currency', maxWidth: 50 },
  { key: 'dateReceived', title: 'Date Received', type: 'date', maxWidth: 50},
  { key: 'status', title: 'Status', type: 'status', maxWidth: 50 },
];

export const lenderRejectedProposalColumns = [
  { key: 'id', title: 'Proposal ID', type: 'proposalId' },
  { key: 'borrowerName', title: 'Borrower Name', type: 'maskedBorrower' },
  { key: 'loanType', title: 'Loan Type', type: 'text' },
  { key: 'loanAmount', title: 'Loan Amount', type: 'currency' },
  { key: 'dateReceived', title: 'Date Received', type: 'date' },
  { key: 'status', title: 'Status', type: 'status' },
  { key: 'industry', title: 'Industry', type: 'text' },
  { key: 'city', title: 'City', type: 'text' },
  { key: 'rejectionReason', title: 'Rejection Reason', type: 'text', color: '#F44336', fontWeight: 500 }
];

export const columnTypes = {
  text: (value) => value || "N/A",
  currency: (value) => value ? `₹${value.toLocaleString()}` : "Not specified",
  date: (value) => value ? new Date(value).toLocaleDateString() : "N/A",
  status: (value) => value || "Unknown",
  proposalId: (value) => value || "N/A"
};

export const createColumnConfig = (key, title, type = 'text', options = {}) => ({
  key,
  title,
  type,
  ...options
});

export const createActionColumn = (title = 'Actions', align = 'right') => ({
  key: 'actions',
  title,
  type: 'actions',
  align
});

export const createReportsColumn = (title = 'Reports') => ({
  key: 'reports',
  title,
  type: 'reports'
});

export const createOffersColumn = (title = 'Offers') => ({
  key: 'offers',
  title,
  type: 'offers'
});